import { useCart } from '../../cart/useCart'
import { formatZARCents } from '../../lib/format'
import { pickReadableTextColor } from '../../lib/contrast'

interface Props {
  onOpen: () => void
  primaryColor: string
}

export function CartBar({ onOpen, primaryColor }: Props) {
  const { lineCount, totalCents } = useCart()
  const textColor = pickReadableTextColor(primaryColor)

  // The live region must always be mounted — a region only reliably announces
  // updates if it already exists in the DOM before its content changes, not
  // when it's freshly inserted with content already present.
  return (
    <>
      <span className="sr-only" aria-live="polite" aria-atomic="true">
        {lineCount > 0
          ? `${lineCount} item${lineCount === 1 ? '' : 's'} in cart, ${formatZARCents(totalCents)}`
          : ''}
      </span>
      {lineCount > 0 && (
        <button
          onClick={onOpen}
          aria-label={`View cart, ${lineCount} item${lineCount === 1 ? '' : 's'}, ${formatZARCents(totalCents)}`}
          className="fixed bottom-0 inset-x-0 z-40 flex items-center justify-between px-5 py-4 font-semibold shadow-lg"
          style={{ backgroundColor: primaryColor, color: textColor }}
        >
          <span>
            {lineCount} item{lineCount === 1 ? '' : 's'}
          </span>
          <span>{formatZARCents(totalCents)}</span>
        </button>
      )}
    </>
  )
}
